<template>
	<div>
		<Header :sel='3' @changePhone="changePhone" />
		<!--neirong-->
		<div :class="['cd-main-content',showPhone?'nav-is-visible':'']">
			<!-- * 内页banner * -->
			<div class="page-banner">
				<img src="@/assets/images/banner02.png" alt="内页banner">
				<div class="nybt">
					<h3>内页banner</h3>
				</div>
			</div>
			<!-- * 当前位置 * -->
			<div class="page-position">
				<div class="wh">
					当前位置：
					<a href="/">首页</a>
					&gt;
					{{title}}
				</div>
			</div>

			<!-- * 主体部分 * -->
			<div class="page-wrap">
				<div class="wh clearfix">


					<!-- * 右侧 * -->
					<div class="page-wrap-right">

						<div class="xypg-left-con2 hidden-sm hidden-xs clearfix">
							<div>
								<ul class="xypg-left-nav">
									<li :class="item.categoryCode==type?'clicked':''" v-for="item in actList">
										<a href="javascript:void(0)"
											@click="changeData(item.categoryCode,item.categoryName)">
											{{item.categoryName}}</a>
										<div class="first-nav-btn"></div>
									</li>
									<!-- <li>
										<a href="02关于恒润 02 企业文化.html">
											企业文化</a>
										<div class="first-nav-btn"></div>
									</li>
									<li>
										<a href="02关于恒润 03 发展历程.html">
											发展历程</a>
										<div class="first-nav-btn"></div>
									</li>
									<li>
										<a href="02关于恒润 04 资质荣誉.html">
											资质荣誉</a>
										<div class="first-nav-btn"></div>
									</li> -->
								</ul>
							</div>
						</div>
						<div class="xypg-right-content">
							<div v-if="title=='公司介绍'||title=='企业文化'">
								<!-- <img :src="detail.image" v-if="detail.image"> -->
								<div v-html="detail.cmsArticleData?detail.cmsArticleData.content:''"></div>
							</div>
							<div v-if="title=='发展历程'">
								<div>
									<div class="fazhan_t">恒润集团发展大事记</div>
									<div class="fazhan_t2">
										<p>2001年成立至今</p>
									</div>
									<ul id="licheng">
										<li :class="index%2 != 1?'li1':'li2'" v-for="(item,index) in list">
											<div class="yuan"><img  src="@/assets/images/yuan.png"/></div>
											<div :class="index%2 != 1?'licheng_txt fr':'licheng_txt fl'">
												<div class="licheng_t1"><strong>{{item.title}}</strong></div>
												<!-- <div class="licheng_t2"><strong>广州圣美养老护理院</strong></div> -->
												<p>{{item.describtion}}</p>
											</div>
											<div class="clear"></div>
										</li>
										<!-- <li class="li2">
									<div class="yuan"><img  src="@/assets/images/yuan.png"/></div>
											<div class="licheng_txt  fl">
												<div class="licheng_t1"><strong>2022年10月</strong></div>
												<div class="licheng_t2"><strong>杭州佳源快乐护理院</strong></div>
												<p>杭州佳源快乐护理院集医养、护理、康复为一体，是目前杭州市规模领先，环境极佳的护理院之一。周围绿树成荫，青草满园，清朗静谧。
													紧邻美地拾光公园，景色怡人，空气清新，让长者亲近自然。</p>
											</div>
											<div class="clear"></div>
										</li>
										<li class="li1">
										<div class="yuan"><img  src="@/assets/images/yuan.png"/></div>
											<div class="licheng_txt  fr">
												<div class="licheng_t1"><strong>2021年7月</strong></div>
												<div class="licheng_t2"><strong>圣德·杭州嘉誉</strong></div>
												<p>坐落于杭州市上城区梅花碑8号<br>
													总面积12000平方米，床位450张<br>
													紧邻杭州城站、市三医院<br>
													浙二医院、浙一医院<br>
													交通便利，疗养相宜</p>
											</div>
											<div class="clear"></div>
										</li>
										<li class="li2">
										<div class="yuan"><img  src="@/assets/images/yuan.png"/></div>
											<div class="licheng_txt  fl">
												<div class="licheng_t1"><strong>2020.8</strong></div>
												<div class="licheng_t2"><strong>圣德·嘉朗</strong></div>
												<p>圣德医养康复集团的旗舰项目<br>
													坐拥市南区优质配套资源<br>
													一站式高端综合医养项目<br>
													集中医康复医院、养老机构、护理中心于一体的综合性颐养中心
													建面约24000㎡，开放床位约600张</p>
											</div>
											<div class="clear"></div>
										</li>
										<li class="li1">
										<div class="yuan"><img  src="@/assets/images/yuan.png"/></div>
											<div class="licheng_txt  fr">
												<div class="licheng_t1"><strong>2019.08</strong></div>
												<div class="licheng_t2"><strong>圣德·嘉康</strong></div>
												<p>隶属于圣德医养康复集团<br>按照五星级养老机构标准建设的<br>配有以老年病为特色的二级专科医院<br>
													养老院总建筑面积约10000㎡，开放床位约600张。</p>
											</div>
											<div class="clear"></div>
										</li>
										<li class="li2">
										<div class="yuan"><img  src="@/assets/images/yuan.png"/></div>
											<div class="licheng_txt  fl">
												<div class="licheng_t1"><strong>2018.12</strong></div>
												<div class="licheng_t2"><strong>圣德·夕阳红</strong></div>
												<p>青岛首批专门收住失智老人的医养机构<br>集团整体收购并重新装修升级<br>于2018年底全新开业</p>
											</div>
											<div class="clear"></div>
										</li>
										<li class="li1">
									<div class="yuan"><img  src="@/assets/images/yuan.png"/></div>
											<div class="licheng_txt  fr">
												<div class="licheng_t1"><strong>2018.09</strong></div>
												<div class="licheng_t2"><strong>圣德·新诚康</strong></div>
												<p>集团首个改造项目，处于李沧核心区域<br>以中医养生治疗、传统中医内病外治<br>为特色的医养结合机构<br>建面约3000㎡，共设置108张床位。
												</p>
											</div>
											<div class="clear"></div>
										</li>
										<li class="li2">
										<div class="yuan"><img  src="@/assets/images/yuan.png"/></div>
											<div class="licheng_txt  fl">
												<div class="licheng_t1"><strong>2018.01</strong></div>
												<div class="licheng_t2"><strong>圣德·虹美</strong></div>
												<p>坐落于李村河畔，风景怡人<br>院区建面4000㎡，设置床位150张<br>
													2018年1月圣德医养康复集团正式接管</p>
											</div>
											<div class="clear"></div>
										</li>
										<li class="li1">
										<div class="yuan"><img  src="@/assets/images/yuan.png"/></div>
											<div class="licheng_txt  fr">
												<div class="licheng_t1"><strong>2016.12</strong></div>
												<div class="licheng_t2"><strong>圣德医养康复集团成立</strong></div>
												<p>标志着圣德医养康复集团<br>正式迈入集团化发展<br>通过收购、新建院区等方式<br>进行规模化、平台化快速扩张
													<br>2019年成为全国首批普惠养老重点参与企业
													<br>是青岛地区唯一上榜的医养企业
												</p>
											</div>
											<div class="clear"></div>
										</li>
										<li class="li2">
										<div class="yuan"><img  src="@/assets/images/yuan.png"/></div>
											<div class="licheng_txt  fl">
												<div class="licheng_t1"><strong>2009.12</strong></div>
												<div class="licheng_t2"><strong>圣德·李沧</strong></div>
												<p>圣德·李沧是圣德医养康复集团的摇篮<br>
													是青岛民营养老的先行者<br>
													是医养结合养老模式的践行者<br>
													开拓了符合国情的养老模式<br>
													是青岛第一家五星级民营养老机构</p>
											</div>
											<div class="clear"></div>
										</li> -->
										<div class="clear"></div>
									</ul>
								</div>
							</div>
							<div v-if="title=='荣誉资质'">
								<div class="tab-box">
									<el-tabs v-model="activeName" @tab-click="handleClick">
										<el-tab-pane label="企业荣誉" name="300006"></el-tab-pane>
										<el-tab-pane label="企业资质" name="300007"></el-tab-pane>
									</el-tabs>
								</div>
								<ul class="xypg-product-list clearfix">
									<li v-for="item in list">
										<a href="javascript:void(0)" class="img"><img :src="item.image" /></a>
										<h3><a href="javascript:void(0)">{{item.title}}</a></h3>
									</li>
								</ul>
								<div class="xypg-pagination">
									<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
										:current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
										layout="total, sizes, prev, pager, next, jumper" :total="total">
									</el-pagination>
								</div>
							</div>
						</div>
					</div>


				</div>
			</div>

			<Footer />
		</div>



		<!--neirong-->


	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import axios from 'axios';


	import {
		articleDetail,
		categorysortPage,
		articleList
	} from '@/api/reqFetch.js'

	export default {
		name: '',
		layout: '',
		components: {
			Footer,
			Header,
		},
		data() {
			return {
				id: '',
				detail: {},
				showPhone: false,
				pageNum: 1,
				pageCount: 0,
				actList: [],
				type: '200003',
				title: '公司介绍',
				activeName: '300006',
				total: 0,
				list: [],
				pageNum: 1,
				totalPage: 0,
				pageSize: 10
			}
		},

		mounted() {

			this.type = this.$route.query.type
			this.title = this.$route.query.title
			this.getCategorysortPage()
			if (this.$route.query.id) {
				this.id = this.$route.query.id
				this.getNewDetail();
			} else {
				this.changeData(this.type, this.title)
			}


		},

		methods: {
			
			handleClick() {
				this.pageNum = 1
				this.getData()
			},
			// 页码容量变化
			handleSizeChange(pageSize) {
				this.pageNum = 1
				this.pageSize = pageSize
				this.getData()
			},

			// 当前页码变化
			handleCurrentChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},

			getData() {
				let par = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					status: 1,
					categoryCode: this.activeName
				}
				articleList(par).then(res => {
					this.list = res.rows;
					this.total = res.total

				});
			},
			getCategorysortPage() {
				categorysortPage({
					pos: 'top'
				}).then(res => {
					res.data.map(item => {
						if (item.categoryName == '关于恒润') {
							this.actList = item.children
							this.actList.sort((a, b) => a.orderNum - b.orderNum);
						}
					})

				});
			},
			changeData(id, title) {
				this.type = id
				this.title = title
				if (this.title == '公司介绍' || this.title == '企业文化') {
					this.pageSize = 1
					this.getCaseList()
				} else if (this.title == '荣誉资质') {
					this.activeName = '300006'
					this.pageSize = 6
					this.getData()
				} else {
					this.pageSize = 99
					this.getCaseList()
				}

			},
			goNext(url) {
				this.$router.push({
					path: url,
				})
			},
			getCaseList() {
				articleList({
					pageNum: 1,
					pageSize: this.pageSize,
					status: 1,
					categoryCode: this.type,
				}).then(res => {
					this.list = res.rows;
					this.total = res.total
					if (this.pageSize == 1) {
						this.id = res.rows[0].id
						this.getNewDetail()
					}
				});
			},

			changePhone(val) {
				this.showPhone = val
			},
			getNewDetail() {
				articleDetail({
					id: this.id
				}).then(res => {
					this.detail = res.data;
					try {
						let cmsArticleData = this.detail.cmsArticleData
						if (cmsArticleData && cmsArticleData.content) {
							// 正则替换空格&nbsp;为一个div元素，
							cmsArticleData.content = cmsArticleData.content.replace(/&nbsp;&nbsp;&nbsp;&nbsp;/g,
								'<div class="su-space"></div>')
						}
						this.detail = {
							...this.detail,
							cmsArticleData: cmsArticleData
						}
					} catch (error) {
						console.error(error)
					}


				});
			},



		}
	}
</script>

<style scoped>
	.tab-box {
		margin: auto;
		width: fit-content;
	}

	.tab-box>>>.el-tabs__item.is-active {
		color: #0070b0 !important;
	}

	.tab-box>>>.el-tabs__item:hover {
		color: #0070b0 !important;
	}

	.tab-box>>>.el-tabs__active-bar {
		background-color: #0070b0 !important;
	}

	.fazhan_t {
		font-size: 18px;
		color: #666;
		text-align: center;
		width: 200px;
		margin-top: 20px;
		margin-right: auto;
		margin-bottom: 0px;
		margin-left: auto;
		padding-top: 2px;
		padding-right: 0px;
		padding-bottom: 2px;
		padding-left: 0px;
		border: 0px solid #ccc;
		font-weight: bold;
		line-height: 40px;
	}

	.fazhan_t2 {
		text-align: center;
		font-size: 12px;
		color: #666;
		line-height: 30px;
		margin-top: 0px;
	}

	.licheng_t1 {
		color: #333;
		font-size: 16px;
	}

	.licheng_t1 strong {
		font-size: 20px;
		color: #333;
	}

	.licheng_t2 {
		color: #333;
		font-size: 14px;
	}

	.licheng_t2 strong {
		font-size: 16px;
		color: #333;
	}
.clear{ clear: both;}
.fl{ float:left; text-align:left; }
.fr{ float:right; text-align:right;}
	ul#licheng {
		background-image: url('../../assets/images/line3.png');
		background-repeat: repeat-y;
		margin-top: 30px;
		margin-right: auto;
		margin-bottom: 0px;
		margin-left: auto;
		padding-top: 20px;
		padding-right: 0px;
		padding-bottom: 20px;
		padding-left: 0px;
		background-position: center center;
	}

	ul#licheng li {
	
		width: 50.01%;
		
		padding: 4%; position: relative;
	}
.li1 .yuan{ position: absolute; right: -9px; }
.li2 .yuan{ position: absolute; left: -9px; }
	.li1 {
	
		float: left; 
	}

	.li2 {
		
		float: right;
	}

	.licheng_img {
		width: 28%;
	}

	.licheng_img img {
		border-radius: 50%;
		border: 2px solid #118785;
		margin-top: 10%;
		width: 100%;
	}

	.licheng_txt {
		font-size: 14px;
		color: #666666;
		width: 72%;
	}
</style>